var map = {
	"./anime.png": 4157,
	"./biology-mechanic.png": 442,
	"./cartoon.png": 355,
	"./cg.png": 5765,
	"./chinese-new.png": 482,
	"./chinese-painting.png": 125,
	"./city-pop.png": 6090,
	"./crystal-punk.png": 4107,
	"./cyberpunk.png": 1477,
	"./epic.png": 4145,
	"./futurism.png": 7446,
	"./ghibli.png": 9589,
	"./impressionism.png": 1379,
	"./interior-design.png": 6117,
	"./low-poly.png": 3886,
	"./matte-painting.png": 239,
	"./neon-game.png": 303,
	"./none.png": 3533,
	"./oil-painting.png": 1916,
	"./photograph.png": 3770,
	"./pixel.png": 3346,
	"./psychedelic.png": 4819,
	"./retrowave-palette.png": 3820,
	"./sketch.png": 1356,
	"./ukiyo-e.png": 9116,
	"./vaporwave.png": 1531,
	"./water-color.png": 2337
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3577;